import { DpOutlinedSelect } from '@/components/blocks/DpOutlineSelect';
import { ProductSizeInput } from '@/components/content/ProductDetails/parts/CompleteLook/style/completeLook';
import { MenuItem, SelectChangeEvent } from '@mui/material';
import { FreeShippingProductSize } from '@/components/blocks/FreeShippingActivatedPopup/parts/types';

interface FreeShippingSizeSelectProps {
	value?: string;
	sizes: FreeShippingProductSize[];
	onChange: (event: SelectChangeEvent<string>) => void;
}

export const FreeShippingSizeSelect = ({ value, sizes, onChange }: FreeShippingSizeSelectProps) => (
	<DpOutlinedSelect
		value={value}
		input={<ProductSizeInput />}
		sx={{
			height: '32px !important',
			'.MuiSelect-nativeInput': {
				padding: '0px',
			},
		}}
		MenuProps={{
			sx: {
				zIndex: 9999999999,
			},
		}}
		onChange={onChange as any}
	>
		<MenuItem disabled value="talla">
			{'Talla'}
		</MenuItem>
		{sizes.map((size) => (
			<MenuItem key={size.partNumber} value={size.partNumber}>
				{size.size}
			</MenuItem>
		))}
	</DpOutlinedSelect>
);
